//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { geoCentroid } from 'd3-geo';
import {
    ComposableMap,
    Geographies,
    Geography,
    Marker,
    Annotation,
} from 'react-simple-maps';

// Components
import SharedLinkForm from './../SharedLinkForm';
import { isAgg } from '../../Common/Helpers';

// Actions
import { clearSharedLink, handleReportDisplayIdChange_DetailedDistrictReport } from './../../../actions/UserActions';
import { clearAllSpending, setSharedLinkStatus, getDetailedDistrictReportConfig } from './../../../actions/DetailedDistrictReportActions';

// import event tracking log
import { withUserActionTracker } from "./../../../sharedUtilities/UserActionTracker";

const NationalMap: React.FC = ({ match }) => {
    // local state
    const [sharedLinkFormDisplay, toggleSharedLinkFormDisplay] = useState(false);
    const [initialName, setInitialName] = useState("");
    const [isAggregate, setIsAggregate] = useState(false);

    // dispatch hook for actions
    const dispatch = useDispatch();

    // global state selectors
    const reportDisplayId = useSelector(state => state.userProperties.report_display_id)
    const reportVintage = useSelector(state => state.userProperties.report_vintage_one_district)
    const initialReportDisplayId = useSelector(state => state.userProperties.report_display_id_initial)
    const initialReportName = useSelector(state => state.userProperties.report_university_name_initial)
    const aggregateDisplayId = useSelector(state => state.detailedDistrictReportProperties.aggregateDisplayId)
    const sharedLinkIsActive = useSelector(state => state.detailedDistrictReportProperties.sharedLinkActive)

    useEffect(() => {

        // shared link toggle set to inactive when paramaters are not available
        if (match.params["link_id"] == undefined &&
            match.params["p1"] == undefined &&
            match.params["p2"] == undefined) {

            dispatch(setSharedLinkStatus(false));
        }
    }, []);

    useEffect(() => {

        setInitialName(initialReportName);

        setIsAggregate(aggregateDisplayId == reportDisplayId)

        dispatch(clearAllSpending());

    }, [initialReportName]);


    const showSharedLinkForm = () => {
        toggleSharedLinkFormDisplay(true);
    }

    const hideSharedLinkFrom = () => {
        toggleSharedLinkFormDisplay(false);
        //clear shared link info
        dispatch(clearSharedLink());
    }

    const allStates = require('./../../MapFiles/all-states-id-val.json');

    const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

    const offsets = {
        VT: [50, -8],
        NH: [34, 2],
        MA: [30, -1],
        RI: [28, 2],
        CT: [35, 10],
        NJ: [34, 1],
        DE: [33, 0],
        MD: [47, 10],
        DC: [49, 21],
    };

    return (
        <div className="national-map">
            <SharedLinkForm reportType="congressional-district-detail-report" showModal={sharedLinkFormDisplay} handleClose={() => hideSharedLinkFrom()} />

            <hr />
            <ComposableMap projection="geoAlbersUsa" className="map-container districtdetailedmap">
                <text x="15" y="35" className="action-headers">SELECT A STATE TO VIEW RESPECTIVE CONGRESSIONAL DISTRICTS</text>
                <Geographies geography={geoUrl}>
                    {({ geographies }) => (
                        <>
                            {geographies.map((geo) => (
                                <Link to={`${match.url}/${geo.id}`} key={geo.rsmKey}>
                                    <Geography
                                        key={geo.rsmKey}
                                        stroke="#FFF"
                                        geography={geo}
                                        fill="#DDD"
                                    />
                                </Link>
                            ))}
                            {geographies.map((geo) => {
                                const centroid = geoCentroid(geo);
                                const cur = allStates.find((s) => s.val === geo.id);
                                return (
                                    <g key={geo.rsmKey + "-name"}>
                                        {cur &&
                                            centroid[0] > -160 &&
                                            centroid[0] < -67 &&
                                            (Object.keys(offsets).indexOf(cur.id) === -1 ? (
                                                <Marker coordinates={centroid}>
                                                    <text y="2" fontSize={14} textAnchor="middle">
                                                        {cur.id}
                                                    </text>
                                                </Marker>
                                            ) : (
                                                <Annotation
                                                    subject={centroid}
                                                    dx={offsets[cur.id][0]}
                                                    dy={offsets[cur.id][1]}
                                                >
                                                    <text x={4} fontSize={14} alignmentBaseline="middle">
                                                        {cur.id}
                                                    </text>
                                                </Annotation>
                                            )
                                            )
                                        }
                                    </g>
                                );
                            })}
                        </>
                    )}
                </Geographies>
            </ComposableMap>
        </div>
    );
}

export default withUserActionTracker(
    NationalMap,
    "Congressional District Detail Report",
    "viewed national map"
);